import React, {FC} from "react"

import {IconTypes} from "@irati/ui/src/Icon"

import MenuLink from "./MenuLink"
import Icon from "../../Icon"

interface Props {
  to: string
}

const MenuLinkLeft: FC<Props> = ({children, ...props}) => (
  <MenuLink {...props}>
    <Icon icon={IconTypes.chevronLeft} marginRight={1} />
    {children}
  </MenuLink>
)

export default MenuLinkLeft
